<div *ngIf="!isMobile && !this.isPanorama()">
  <mat-divider></mat-divider>

  <div class="banner">
    <!-- start : left elements -->
    <div class="left-item-banner">
      <!-- start : List of button element-->
      <div class="banner-download-button">
        <a
          mat-fab
          href="https://play.google.com/store/apps/details?id=com.irealite.mybalade"
          target="_blank"
          (click)="sendGaEvent('Google Play', 'Play Store')"
          title="Google store"
        >
          <mat-icon aria-hidden="true" svgIcon="google_store"></mat-icon>
        </a>
        <div fxFlex=""></div>
        <a
          mat-fab
          href="https://apps.apple.com/us/app/valdoise-mybalade/id990253291?l=fr&ls=1"
          target="_blank"
          title="Apple store"
          (click)="sendGaEvent('AppStore', 'Play Store')"
          ><i class="material-icons" aria-hidden="true">apple</i>
        </a>
      </div>
      <!-- end : List of button element-->
      <!-- start : List of text element-->
      <div class="banner-download-text">
        <span>Téléchargez l'application</span>
        <br />
        <span>et découvrez les ressources du Val d‘Oise en toute mobilité</span>
      </div>
      <!-- end : List of text element-->
    </div>
    <!-- end : left elements -->

    <!-- start : separator -->
    <div fxFlex=""></div>
    <!-- end : separator -->

    <!--  icon right  -->
    <div class="logo-banner">
      <!-- ? GA : Partenaire ? -->
      <a
        href="https://www.valdoise.fr/"
        (click)="
          sendGaEvent('url', 'Site Web Extérieur', 'https://www.valdoise.fr/')
        "
        target="_blank"
      >
        <img
          class="logo smol"
          src="assets/logos/logo_Val_Oise.png"
          alt="logo région Val d‘Oise"
        />
      </a>
      <!-- ? GA : Partenaire ? -->
      <!-- ? GA : Partenaire ? -->
      <!-- <a href="https://www.iledefrance.fr/" (click)="sendGaEvent('url', 'Site Web Extérieur', 'https://www.iledefrance.fr/')" target="_blank">
        <img class="logo bog" src="assets/logos/ridf.jpg" alt="logo région Ile de France" />
      </a> -->
      <!-- ? GA : Partenaire ? -->
      <!-- ? GA : Partenaire ? -->
      <!-- <a
        href="https://www.culture.gouv.fr/"
        (click)="sendGaEvent('url', 'Site Web Extérieur', 'https://www.culture.gouv.fr/')"
        target="_blank"
      >
        <img class="logo smol" src="assets/logos/LogoMCHP.png" alt="Logo ministère de la culture" />
      </a> -->
      <!-- ? GA : Partenaire ? -->
      <!-- ? GA : Partenaire ? -->
      <a
        href="https://www.gouvernement.fr/les-priorites/france-relance"
        (click)="
          sendGaEvent(
            'url',
            'Site Web Extérieur',
            'https://www.gouvernement.fr/les-priorites/france-relance'
          )
        "
        target="_blank"
      >
        <img
          class="logo smol"
          src="assets/logos/Logo France Relance_2.png"
          alt="logo France Relance"
        />
      </a>
      <!-- ? GA : Partenaire ? -->
      <!-- ? GA : Partenaire ? -->
      <a
        href="https://commission.europa.eu/strategy-and-policy/recovery-plan-europe_fr"
        (click)="
          sendGaEvent(
            'url',
            'Site Web Extérieur',
            'https://commission.europa.eu/strategy-and-policy/recovery-plan-europe_fr'
          )
        "
        target="_blank"
      >
        <img
          class="logo smol"
          src="assets/logos/FR Finance par Union europenne_Horizontal2.png"
          alt="logo Union Européeene"
        />
      </a>
      <!-- ? GA : Partenaire ? -->
    </div>
    <!-- start : right elements -->
    <div class="right-item-banner">
      <!-- ? GA : Partenaire ? -->
      <a
        routerLink="about/partenaires"
        (click)="sendGaEvent('Partenaire', 'Info')"
        translate="Partners"
      ></a>
      <!-- ? GA : Partenaire ? -->
      <mat-divider [vertical]="true"></mat-divider>
      <!-- ? GA : CGU ? -->
      <a
        routerLink="about/cgu"
        (click)="sendGaEvent('cgu ml', 'Info')"
        translate="TOS"
      ></a>
      <!-- ? GA : CGU ? -->
      <mat-divider [vertical]="true"></mat-divider>
      <!-- ? GA : Info ? -->
      <a
        routerLink="about/info"
        (click)="sendGaEvent('Info', 'Info')"
        translate="Info"
      ></a>
      <!-- ? GA : Info ? -->
    </div>
    <!-- end : right elements -->
  </div>

  <div class="sep"></div>

  <div class="footer">
    <div *ngIf="currentScreenWidth > 1000" class="footer-logo">
      <img src="assets/logos/logo_header_dark.png" alt="Val d‘oise logo" />
    </div>
    <mat-grid-list
      cols="3"
      rowHeight="400px"
      class="footer-nav {{
        currentScreenWidth > 1000 ? 'footer-nav-margin' : ''
      }}"
    >
      <mat-grid-tile>
        <div fxFill>
          <mat-list class="mat-list-center" dense>
            <mat-list-item>
              <mat-icon color="primary">explore</mat-icon>
              <h3
                matSubheader
                class="footer-cat-title"
                translate="Explore"
              ></h3>
            </mat-list-item>
            <div class="nav-block">
              <mat-list-item>
                <!-- ? GA : Carte ? -->
                <a
                  class="footer-cat-elem"
                  routerLink="/carte"
                  (click)="sendGaEvent('-', 'Territoire')"
                  >Tout le territoire</a
                >
                <!-- ? GA : Carte ? -->
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.heritage.id }}"
                  (click)="
                    sendGaEvent('-', 'Patrimoine');
                    sendGaEvent('TOUS - patrimoine', 'Sous-catégorie')
                  "
                  translate="Heritages"
                ></a>
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.circuit.id }}"
                  (click)="
                    sendGaEvent('-', 'Circuits');
                    sendGaEvent('TOUS - circuits', 'Sous-catégorie')
                  "
                  translate="Circuits"
                ></a>
              </mat-list-item>
            </div>

            <mat-list-item class="footer-nav-cat">
              <mat-icon color="primary">event</mat-icon>
              <h3 matSubheader class="footer-cat-title" translate="Events"></h3>
            </mat-list-item>
            <div class="nav-block">
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.event.id }}"
                  (click)="sendGaEvent('-', 'Agenda')"
                  >Tous les évènements</a
                >
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.event.id }}/0"
                  (click)="sendGaEvent('-', 'Agenda')"
                  translate="Ongoing"
                ></a>
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.event.id }}/1"
                  (click)="sendGaEvent('-', 'Agenda')"
                  translate="Forthcoming"
                ></a>
              </mat-list-item>
            </div>
          </mat-list>
        </div>
      </mat-grid-tile>

      <mat-grid-tile>
        <div fxFill>
          <mat-list class="mat-list-center" dense>
            <mat-list-item>
              <mat-icon color="primary">sentiment_very_satisfied</mat-icon>
              <h3 matSubheader class="footer-cat-title" translate="ToDo"></h3>
            </mat-list-item>
            <div class="nav-block">
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.services.id }}/{{
                    subCategories.activities.id
                  }}"
                  (click)="
                    sendGaEvent('-', 'Services');
                    sendGaEvent('Activités et Loisirs', 'Sous-catégorie')
                  "
                  translate="Hobbies"
                ></a>
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.games.id }}"
                  (click)="sendGaEvent('-', 'Jeux')"
                  translate="Games"
                ></a>
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.event.id }}/2"
                  translate="Outing"
                ></a>
              </mat-list-item>
            </div>
          </mat-list>
        </div>
      </mat-grid-tile>

      <mat-grid-tile>
        <div fxFill>
          <mat-list class="mat-list-center" dense>
            <mat-list-item>
              <mat-icon color="primary" svgIcon="icon_Services"></mat-icon>
              <h3
                matSubheader
                class="footer-cat-title"
                translate="Services"
              ></h3>
            </mat-list-item>
            <div class="nav-block">
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.services.id }}"
                  (click)="
                    sendGaEvent('-', 'Services');
                    sendGaEvent('TOUS - services', 'Sous-catégorie')
                  "
                  >Tous les services</a
                >
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.services.id }}/{{
                    subCategories.lodging.id
                  }}"
                  (click)="
                    sendGaEvent('-', 'Services');
                    sendGaEvent('Hébergement', 'Sous-catégorie')
                  "
                  translate="Lodging"
                ></a>
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.services.id }}/{{
                    subCategories.restaurants.id
                  }}"
                  (click)="
                    sendGaEvent('-', 'Services');
                    sendGaEvent('Restaurants', 'Sous-catégorie')
                  "
                  translate="Restaurants"
                ></a>
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.services.id }}/{{
                    subCategories.shopping.id
                  }}"
                  (click)="
                    sendGaEvent('-', 'Services');
                    sendGaEvent('Commerces et services', 'Sous-catégorie')
                  "
                  translate="Shops"
                ></a>
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.services.id }}/{{
                    subCategories.touristInfo.id
                  }}"
                  (click)="
                    sendGaEvent('-', 'Services');
                    sendGaEvent('Informations touristiques', 'Sous-catégorie')
                  "
                  translate="touristInfo"
                ></a>
              </mat-list-item>
              <mat-list-item>
                <a
                  class="footer-cat-elem"
                  routerLink="/carte/{{ categories.services.id }}/{{
                    subCategories.productLocaux.id
                  }}"
                  (click)="
                    sendGaEvent('-', 'Services');
                    sendGaEvent('Producteurs locaux', 'Sous-catégorie')
                  "
                  translate="productLocaux"
                ></a>
              </mat-list-item>
            </div>
          </mat-list>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</div>
